import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges,
    OnDestroy,
    Output,
    Renderer2, SimpleChanges,
    ViewChild
} from '@angular/core';
import {FileUploadService} from "../../services/file-upload.service";
import {HttpHeaders, HttpResponse} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {SessionService} from "../../../session/session.service";
import {InterfaceProviderService} from "../../../basic-entity-back/services/interface-provider.service";
import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {debounceTime, finalize, map} from "rxjs/operators";
import {ObjViewerService} from "../../../services/obj-viewer.service";
import {ApiService} from "../../../api/api.service";
import {saveAs} from 'file-saver';
import {FormGroup} from "@angular/forms";
import {InternalPropertyMap} from "../../../basic-entity-back/basic-entity-interface/mapping-internal";
import * as JSZip from "jszip";

@Component({
    selector: 'be-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements AfterViewInit, OnDestroy, OnChanges {

    progress = 0;
    progressType = '';
    message = '';
    isArray = false;

    private removeSubscription = new BehaviorSubject<boolean>(false);
    private subscriptions: Subscription[] = [];

    @ViewChild('objViewer') objViewer: ElementRef;
    @ViewChild('lineaArchivo') lineaArchivo: ElementRef;
    @Input() claseUploader = '';
    @Input() buttonName = '';
    @Input() isInput = false;
    @Input() listaArchivos: any[] = [];
    @Output() public fileUploadedEmmiter = new EventEmitter<any[]>();
    @Output() public fileRemovedEmitter = new EventEmitter<any>();
    @Output() public seleccionEmmiter = new EventEmitter<any>();
    @Input() mostrarVisor = true;
    @Input() seleccionarPrimero = true;
    @Input() archivoSeleccionado: any = null;
    @Input() archivoSiguiente: any = null;
    @Input() disableButton = false;
    @Input() modelType = null;
    @Input() parentModelType = null;
    @Input() multiple: boolean = true;
    @Input() actualizarVisor = new BehaviorSubject<boolean>(false);
    private clicked = new Subject<any>();
    private urlFile = environment.uploaderUrl;
    @Input() formGroup: FormGroup = null;
    @Input() property: InternalPropertyMap = null;
    @Input() controlName: string | null = null;
    @Input() tiposArchivoSoportados: string[] = ['*'];
    archivosSoportados: string = '';
    seleccionando = false;
    cambio = new BehaviorSubject<any[]>([]);

    constructor(private uploadService: FileUploadService, private sessionService: SessionService, private interfaceProvider: InterfaceProviderService,
                private readonly _objViewerService: ObjViewerService, private readonly _renderer: Renderer2, private apiService: ApiService) {

        let params = new HttpHeaders();
        params = params.append('Authorization', 'Bearer ' + sessionService.token.token);
        this.uploadService.setBaseUrl(this.urlFile);
        this.uploadService.setRequestHeaders(params);
        this.uploadService.progressCompressObserver.subscribe(percent => {
            this.progress = percent;
            this.progressType = 'Comprimido';
        });
        this.uploadService.progressUploadObserver.subscribe(percent => {
            this.progress = percent;
            this.progressType = 'Subido';
        });
        this.removeSubscription.subscribe(result => {
            if (result) {
                this.subscriptions.forEach(sus => sus.unsubscribe());
            }
        })
        this.cambio.subscribe(result => {
            console.log(result)
        })
    }

    ngAfterViewInit(): void {
        if (this.tiposArchivoSoportados && this.tiposArchivoSoportados.length > 0) {
            this.archivosSoportados = this.tiposArchivoSoportados.join(',');
            this.archivosSoportados += this.tiposArchivoSoportados.map(a => a.toUpperCase()).join(',');
        }

        if (this.mostrarVisor) {
            this._objViewerService.iniciarEscena(this._renderer, this.objViewer.nativeElement);

            this.actualizarVisor.subscribe(actualizar => {
                if (actualizar) {
                    if (!this._objViewerService.escenaIniciada()) {
                        this._objViewerService.iniciarEscena(this._renderer, this.objViewer.nativeElement);
                    }

                    if (this.archivoSeleccionado) {
                        const url = this.urlFile + '/' + this.archivoSeleccionado.id + '/descargar';
                        if (this.mostrarVisor) {
                            this._objViewerService.loadObj(url, this.archivoSeleccionado.nombreFichero);
                        }
                    }
                }
            })
        }


        // Para evitar el doble click en el objeto
        const buttonClickedDebounced = this.clicked.pipe(debounceTime(350));
        buttonClickedDebounced.subscribe((archivo: any) => {
            this.enviarSeleccion(archivo)
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disableButton) {
            this.disableButton = changes.disableButton.currentValue;
        }

        if (changes.archivoSeleccionado && (changes.archivoSeleccionado.previousValue !== changes.archivoSeleccionado.currentValue)) {
            if (changes.archivoSeleccionado.currentValue === undefined || changes.archivoSeleccionado.currentValue === null) {
                this._objViewerService.limpiarObj();
            }
            this.actualizarVisor.next(true);
        }

        if (changes.listaArchivos && changes.listaArchivos.currentValue && changes.listaArchivos.currentValue.length === 0 && this.objViewer) {
            this._objViewerService.limpiarObj();
        }

        if (changes.modelType && changes.modelType.currentValue && changes.modelType.currentValue !== changes.modelType.previousValue) {
            this.modelType = changes.modelType.currentValue;
            this.urlFile = this.modelType ? environment.apiUrl + '/' + this.interfaceProvider.interfaceForModel(this.modelType).endpoint : environment.uploaderUrl;
            this.uploadService.setBaseUrl(this.urlFile);

        }
    }

    ngOnDestroy(): void {
        this._objViewerService.limpiarEscena();
        this.subscriptions.forEach(sus => sus.unsubscribe());
    }

    selectFile(event: any): void {
        this.seleccionando = true;
        if (event.target.files && event.target.files.length > 0) {
            const fileListAsArray = Array.from(event.target.files);
            fileListAsArray.forEach((file: File) => {
                if (file.name.toLowerCase().endsWith('.zip')) {
                    if (this.multiple) {
                        this.unzipAndUpload(file);
                    } else {
                        this.seleccionando = false;
                    }
                } else {
                    this.upload(file, this.parentModelType);
                }
            });
        }
    }

    private unzipAndUpload(zipFile: File) {
        JSZip.loadAsync(zipFile).then(zip => {
            const filesToUpload: { name: string, content: Blob }[] = [];
            const promises = [];

            zip.forEach((relativePath, zipEntry) => {
                if (!zipEntry.dir) {
                    const promise = zipEntry.async('blob').then(content => {
                        filesToUpload.push({
                            name: relativePath,
                            content: content
                        });
                    });
                    promises.push(promise);
                }
            });

            Promise.all(promises).then(() => {
                filesToUpload.forEach(f => {
                    const file = new File([f.content], f.name);
                    this.upload(file, this.parentModelType);
                });
            });
        });
    }


    upload(file: File, type: any): void {
        this.progress = 0;
        let files = [];
        this.message = "";
        if (file) {
            this.subscriptions.push(this.uploadService.upload(file, type).pipe(finalize(() => {
                this.enviarSeleccion(this.listaArchivos[this.listaArchivos.length - 1]);
            })).subscribe(
                (event: any) => {
                    if (event instanceof HttpResponse) {
                        if (Array.isArray(event.body)) {
                            files = event.body.map(file => {
                                this.interfaceProvider.interfaceForModel(this.modelType).fromPostToModel(file)
                            });
                            this.listaArchivos.push(...files);
                            this.fileUploadedEmmiter.next(this.listaArchivos);
                        } else {
                            files.push(this.interfaceProvider.interfaceForModel(this.modelType).fromPostToModel(event.body));
                            this.listaArchivos.push(...files);
                            this.fileUploadedEmmiter.next(this.listaArchivos);
                        }
                        this.seleccionando = false;
                        this.cambio.next(this.listaArchivos);
                    }
                },
                (err: any) => {
                    this.progress = 0;
                    if (err.error && err.error.message) {
                        this.message = err.error.message;
                    } else {
                        this.message = 'Could not upload the file!';
                    }

                    this.seleccionando = false;
                }));
        }
    }


    dropEvent(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const items = event.dataTransfer.items;

        if (items.length === 1 && items[0].kind === 'file') {
            const file = items[0].getAsFile();
            if (file && file.name.toLowerCase().endsWith('.zip')) {
                if (this.multiple) {
                    this.progress = 1;
                    this.unzipAndUpload(file);
                } else {
                    this.message = 'Tipo de archivo no válido';
                    this.progress = 0;
                }
                return;
            }
        }

        this.progress = 1;
        this.uploadService.proccessDropEventFiles(items).subscribe(file => {
            if (file.name.toLowerCase().endsWith('.zip')) {
                if (this.multiple) {
                    this.unzipAndUpload(file);
                } else {
                    this.message = 'Tipo de archivo no válido';
                    this.progress = 0;
                }
            } else {
                this.upload(file, this.parentModelType);
            }
        });
    }

    onDragOver(event: DragEvent) {
        event.stopPropagation();
        event.preventDefault();
    }


    update(archivos: any[]) {
        this.listaArchivos.push(...archivos);
    }

    borrar(archivo: any, i) {
        this.uploadService.remove(archivo).subscribe(() => {
            this.listaArchivos.splice(i, 1);
            if (this.mostrarVisor && this.listaArchivos.length > 0) {
                this.enviarSeleccion(this.listaArchivos[i]);
            }
        });
        this.fileRemovedEmitter.emit(archivo)
    }

    borrarTodos() {
        this.listaArchivos.forEach((archivo, index) => this.uploadService.remove(archivo).subscribe(() => {
            if (index === this.listaArchivos.length - 1) {
                this.listaArchivos = [];
                this.enviarSeleccion(null);
            }
        }));
    }

    click(archivo?: any) {
        this.archivoSiguiente = archivo;
        this.clicked.next(archivo)
    }

    enviarSeleccion(archivo?: any) {
        this.archivoSiguiente = null;
        this.seleccionEmmiter.next(archivo);
    }

    nombreFichero(archivo: any) {
        return archivo ? archivo.nombreFichero : '';
    }

    puedeEliminar(archivo) {
        const esComercial = this.sessionService.hasRole('ROLE_COMERCIAL');
        return !esComercial && !this.disableButton && this.archivoSeleccionado && this.archivoSeleccionado.id === archivo.id
    }

    descargar(archivo: any, i: number) {
        const url = environment.apiUrl + '/' + this.interfaceProvider.interfaceForModel(archivo.modelType).endpoint + '/' + archivo.id + '/descargar';
        this.apiService.get(url, null, null, 'blob').pipe(map(res => res.body)).subscribe((res: any) => {
            saveAs(res, archivo.nombreFichero);
        });
    }

    puedeDescargar(archivo: any) {
        const esComercial = this.sessionService.hasRole('ROLE_COMERCIAL');
        return !esComercial && this.archivoSeleccionado && this.archivoSeleccionado.id === archivo.id
    }
}
